module.exports = __webpack_public_path__ + "media/images/category/feature/coj_e/hero-5ed31183727397bedd0e8c4e44723b5e.jpg";